const en_whs_returnsup = {
    "": "supplier return",
    detail: "supplier return detail",
}

export default en_whs_returnsup;